module.exports = __webpack_public_path__ + "static/media/file-text.ddb3a541.svg";